export default "__VITE_ASSET__CnXbgaJp__"